import { VariantProps, cva } from 'class-variance-authority'
import { FC, MouseEventHandler, memo } from 'react'
import { getFileUrl } from '~/helpers/fileUploadHelpers'

export const avatarVariants = cva(
  'user-select-none aspect-square bg-foreground text-background shrink-0 grow-0 font-semibold text-center flex items-center justify-items-center',
  {
    variants: {
      size: {
        sm: 'w-[23px] text-[9px]',
        md: 'w-[30px] text-[10px]',
        lg: 'w-[50px] text-[20px]',
      },
      rounded: {
        full: 'rounded-full',
        md: 'rounded-md',
        sm: 'rounded-md',
      },
    },
    defaultVariants: {
      size: 'md',
      rounded: 'full',
    },
  },
)

export const Avatar: FC<AvatarProps> = memo(
  ({
    firstName = '',
    lastName = '',
    avatarFileId,
    onClick,
    size,
    rounded,
    className,
  }) => {
    return avatarFileId ? (
      <img
        className={avatarVariants({ size, rounded, className })}
        onClick={onClick}
        src={getFileUrl(avatarFileId, { redirect: 'true' })}
        alt={firstName ?? 'avatar'}
      />
    ) : firstName || lastName ? (
      <div className={avatarVariants({ size, rounded, className })} onClick={onClick}>
        <span className="grow uppercase">{`${firstName.charAt(0)}${lastName.charAt(0)}`}</span>
      </div>
    ) : (
      <div />
    )
  },
)

interface AvatarProps extends VariantProps<typeof avatarVariants> {
  firstName?: string
  lastName?: string
  avatarFileId?: ID | null
  onClick?: MouseEventHandler
  className?: string
}
